import React from 'react'

import Hero from '../components/Hero/Hero'
import NewCollection from '../components/NewCollections/NewCollection';

// import Gallery from '../components/Gallery/Gallery';
import About from '../components/About/About';
import HomeCard from '../components/HomeCard/HomeCard';
import Featured from '../components/Featured Item/Featured';
import Featured2 from '../components/Featured Item/Featured2';
import BlogCard from '../components/BlogCard/BlogCard';
import HomeAccessories from '../components/HomeAccessories/HomeAccessories';
import Social from '../components/Social/Social';


function Home() {
    return (
        <div className=''>

            <Hero />
{/* ================================================================================================================================================== */}
            
{/* ================================================================================================================================================== */}
            <NewCollection/>
{/* ================================================================================================================================================== */}
            <Featured/>
{/* ================================================================================================================================================== */}
            <About/>
{/* ================================================================================================================================================== */}
            <HomeAccessories/>
{/* ================================================================================================================================================== */}
            <Featured2/>
{/* ================================================================================================================================================== */}
            <BlogCard/>
{/* ================================================================================================================================================== */}

{/* ================================================================================================================================================== */}
            <HomeCard/>
{/* ================================================================================================================================================== */}
            <Social/>
{/* ================================================================================================================================================== */}

        </div>
    )
}

export default Home
